var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFunnelXmarkIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7673 15.8417L13.1423 13.4834L10.7673 11.1251L11.9506 9.95006L14.3256 12.2917L16.6589 9.95006L17.8423 11.1251L15.5006 13.4834L17.8423 15.8417L16.6589 17.0167L14.3256 14.6501L11.9506 17.0167L10.7673 15.8417ZM9.32561 15.0501C9.35894 15.3001 9.27561 15.5667 9.08394 15.7417C8.75894 16.0667 8.23394 16.0667 7.90894 15.7417L4.56727 12.4001C4.37561 12.2084 4.29227 11.9501 4.32561 11.7084V7.44173L0.333939 2.3334C0.0506057 1.97506 0.117272 1.45007 0.475606 1.16673C0.633939 1.05007 0.808939 0.983398 0.992272 0.983398H12.6589C12.8423 0.983398 13.0173 1.05007 13.1756 1.16673C13.5339 1.45007 13.6006 1.97506 13.3173 2.3334L9.32561 7.44173V15.0501ZM2.69227 2.65007L5.99227 6.86673V11.4667L7.65894 13.1334V6.8584L10.9589 2.65007H2.69227Z",
    fill: "#DD6FD1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFunnelXmarkIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/funnel-xmark-icon.756b7f5083132746039a3187af008e8c.svg";